import React from 'react';
import { translate } from 'i18n/localize';

const PRIVACY_POLICY_URL = 'https://www.proofpoint.com/us/privacy-policy';
const TERMS_OF_SERVICE_URL = 'https://www.proofpoint.com/us/legal/license';
const SUPPORT_URL = 'https://proofpointcommunities.force.com/community/s/digital-risk';

const FooterLink = ({ children, href }) => (
  <a href={href} target='_blank' rel='noreferrer'>{children}</a>
)

const PreLoginFooter = () => (
  <footer className='preLoginFooter'>
    <div className='preLoginFooterCopyright'>
      {translate('footer_copyright_v2').replace('__CURYEAR__', new Date().getFullYear().toString())}
    </div>
    <div className='preLoginFooterLinks'>
      <FooterLink href={PRIVACY_POLICY_URL}>
        {translate('link_privacy')}
      </FooterLink>
      <FooterLink href={TERMS_OF_SERVICE_URL}>
        {translate('link_terms')}
      </FooterLink>
      <FooterLink href={SUPPORT_URL}>
        {translate('link_support')}
      </FooterLink>
    </div>
  </footer>
)

export default PreLoginFooter;
